import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F9as extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      autoridad_revisora: "AUDITORÍA SUPERIOR DEL ESTADO DE NAYARIT",
      orden_de_auditoria: "",
      no_de_auditoria: "",
      fecha_de_inicio: null,
      oficio_de_solicitud: "",
      fecha_de_acuse: null,
      oficio_de_atencion: "",
      fecha_de_acuse_1: null,
      estado_actual: "",
      observaciones: "",
      mas_observaciones: [],
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f9as: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F9a/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f9as: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/9a/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      autoridad_revisora: "AUDITORÍA SUPERIOR DEL ESTADO DE NAYARIT",
      orden_de_auditoria: "",
      no_de_auditoria: "",
      fecha_de_inicio: null,
      oficio_de_solicitud: "",
      fecha_de_acuse: null,
      oficio_de_atencion: "",
      fecha_de_acuse_1: null,
      estado_actual: "",
      observaciones: "",
      mas_observaciones: [],
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    let mas_observaciones = JSON.parse(row.mas_observaciones)
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      autoridad_revisora: row.autoridad_revisora,
      orden_de_auditoria: row.orden_de_auditoria,
      no_de_auditoria: row.no_de_auditoria,
      fecha_de_inicio: row.fecha_de_inicio,
      oficio_de_solicitud: row.oficio_de_solicitud,
      fecha_de_acuse: row.fecha_de_acuse,
      oficio_de_atencion: row.oficio_de_atencion,
      fecha_de_acuse_1: row.fecha_de_acuse_1,
      estado_actual: row.estado_actual,
      observaciones: row.observaciones,
      mas_observaciones: mas_observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      autoridad_revisora: row.autoridad_revisora,
      orden_de_auditoria: row.orden_de_auditoria,
      no_de_auditoria: row.no_de_auditoria,
      fecha_de_inicio: row.fecha_de_inicio,
      oficio_de_solicitud: row.oficio_de_solicitud,
      fecha_de_acuse: row.fecha_de_acuse,
      oficio_de_atencion: row.oficio_de_atencion,
      fecha_de_acuse_1: row.fecha_de_acuse_1,
      estado_actual: row.estado_actual,
      observaciones: row.observaciones,
      mas_observaciones: JSON.parse(row.mas_observaciones),
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      autoridad_revisora: this.state.autoridad_revisora,
      orden_de_auditoria: this.state.orden_de_auditoria,
      no_de_auditoria: this.state.no_de_auditoria,
      fecha_de_inicio: this.state.fecha_de_inicio,
      oficio_de_solicitud: this.state.oficio_de_solicitud,
      fecha_de_acuse: this.state.fecha_de_acuse,
      oficio_de_atencion: this.state.oficio_de_atencion,
      fecha_de_acuse_1: this.state.fecha_de_acuse_1,
      estado_actual: this.state.estado_actual,
      observaciones: this.state.observaciones,
      mas_observaciones: this.state.mas_observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F9a", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      autoridad_revisora: this.state.autoridad_revisora,
      orden_de_auditoria: this.state.orden_de_auditoria,
      no_de_auditoria: this.state.no_de_auditoria,
      fecha_de_inicio: this.state.fecha_de_inicio,
      oficio_de_solicitud: this.state.oficio_de_solicitud,
      fecha_de_acuse: this.state.fecha_de_acuse,
      oficio_de_atencion: this.state.oficio_de_atencion,
      fecha_de_acuse_1: this.state.fecha_de_acuse_1,
      estado_actual: this.state.estado_actual,
      observaciones: this.state.observaciones,
      mas_observaciones: this.state.mas_observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F9a/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F9a/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeAutoridadRevisora = e => {
    this.setState({ autoridad_revisora: e.target.value });
  };

  onChangeOrdenDeAuditoria = e => {
    this.setState({ orden_de_auditoria: e.target.value });
  };

  onChangeNoDeAuditoria = e => {
    this.setState({ no_de_auditoria: e.target.value });
  };

  onChangeFechaDeInicio = e => {
    this.setState({ fecha_de_inicio: e.target.value });
  };

  onChangeOficioDeSolicitud = e => {
    this.setState({ oficio_de_solicitud: e.target.value });
  };

  onChangeFechaDeAcuse = e => {
    this.setState({ fecha_de_acuse: e.target.value });
  };

  onChangeOficioDeAtencion = e => {
    this.setState({ oficio_de_atencion: e.target.value });
  };

  onChangeFechaDeAcuse1 = e => {
    this.setState({ fecha_de_acuse_1: e.target.value });
  };

  onChangeEstadoActual = e => {
    this.setState({ estado_actual: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  addObservacion = (e) => {
    let mas_observacione = { no_de_observacion: "", resumen: "", tipo_observacion: "DISCIPLINARIA", monto: "", probalbe_responsable: "" }
    let mas_observaciones = [...this.state.mas_observaciones, mas_observacione]
    this.setState({ mas_observaciones: mas_observaciones })
  };

  dellObservacion = (i) => {
    let mas_observaciones = this.state.mas_observaciones
    mas_observaciones.splice(i, 1)
    this.setState({ mas_observaciones: mas_observaciones })
  };

  onChangeMasObservacionesData = (i, n, e) => {
    let mas_observaciones = [...this.state.mas_observaciones]
    let mas_observacione = { ...mas_observaciones[i] }
    mas_observacione[n] = e.target.value
    mas_observaciones[i] = mas_observacione
    this.setState({ mas_observaciones: mas_observaciones })
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"9a"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "autoridad_revisora",
        text: "Autoridad Revisora",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "orden_de_auditoria",
        text: "Orden De Auditoria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "no_de_auditoria",
        text: "No De Auditoria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_inicio",
        text: "Fecha De Inicio",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "oficio_de_solicitud",
        text: "Oficio De Solicitud",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_acuse",
        text: "Fecha De Acuse",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "oficio_de_atencion",
        text: "Oficio De Atencion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_acuse_1",
        text: "Fecha De Acuse",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "estado_actual",
        text: "Estado Actual",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ESTADO QUE GUARDAN LAS AUDITORÍAS 2020</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 9a referente
                a estado que guardan las auditorías 2020, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f9as}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="9a" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=9a"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Autoridad Revisora:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="autoridad_revisora"
                  value={this.state.autoridad_revisora}
                  onChange={this.onChangeAutoridadRevisora}
                >
                  <option>AUDITORÍA SUPERIOR DEL ESTADO DE NAYARIT</option>
                  <option>AUDITORÍA SUPERIOR DE LA FEDERACIÓN</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Orden De Auditoria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="orden_de_auditoria"
                  value={this.state.orden_de_auditoria}
                  onChange={this.onChangeOrdenDeAuditoria}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No De Auditoria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_de_auditoria"
                  value={this.state.no_de_auditoria}
                  onChange={this.onChangeNoDeAuditoria}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Inicio:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_inicio"
                  value={this.state.fecha_de_inicio}
                  onChange={this.onChangeFechaDeInicio}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Oficio De Solicitud:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="oficio_de_solicitud"
                  value={this.state.oficio_de_solicitud}
                  onChange={this.onChangeOficioDeSolicitud}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Acuse:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_acuse"
                  value={this.state.fecha_de_acuse}
                  onChange={this.onChangeFechaDeAcuse}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Oficio De Atencion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="oficio_de_atencion"
                  value={this.state.oficio_de_atencion}
                  onChange={this.onChangeOficioDeAtencion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Acuse:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_acuse_1"
                  value={this.state.fecha_de_acuse_1}
                  onChange={this.onChangeFechaDeAcuse1}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estado Actual:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="estado_actual"
                  value={this.state.estado_actual}
                  onChange={this.onChangeEstadoActual}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
              <br></br>
              <Col xs="12" md="12" lg="12">
                <h5 style={{ color: "white" }}>.</h5>
              </Col>
              <Col xs="12" md="12" lg="12">
                <h5>Más Observaciones</h5>
              </Col>
              <br></br>

              <Col xs="12">
                {(this.state.mas_observaciones).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="2">
                      {i == 0 &&
                        <Form.Label>
                          No. De Observación:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="no_de_observacion"
                        value={ele.no_de_observacion}
                        onChange={(e) => this.onChangeMasObservacionesData(i, "no_de_observacion", e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Resumen:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="resumen"
                        value={ele.resumen}
                        onChange={(e) => this.onChangeMasObservacionesData(i, "resumen", e)}
                      />
                    </Col>
                    <Col xs="12" md="2">
                      {i == 0 &&
                        <Form.Label>
                          Tipo De Observación:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        as="select"
                        custom
                        type="text"
                        name="tipo_de_observacion"
                        value={ele.tipo_de_observacion}
                        onChange={(e) => this.onChangeMasObservacionesData(i, "tipo_de_observacion", e)}
                      >
                        <option>DISCIPLINARIA</option>
                        <option>RESARCITORIA</option>
                      </Form.Control>
                    </Col>
                    <Col xs="12" md="2">
                      {i == 0 &&
                        <Form.Label>
                          Monto (En Su Caso):
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="monto"
                        value={ele.monto}
                        onChange={(e) => this.onChangeMasObservacionesData(i, "monto", e)}
                      />
                    </Col>
                    <Col xs="12" md="2">
                      {i == 0 &&
                        <Form.Label>
                          Probable Responsable:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="probable_responsable"
                        value={ele.probable_responsable}
                        onChange={(e) => this.onChangeMasObservacionesData(i, "probable_responsable", e)}
                      />
                    </Col>

                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Observación." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellObservacion(i, e)}
                        data-tip="Eliminar Observación"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addObservacion}
                      data-tip="Agregar Observación"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Observación
                    </button>
                  </Col>
                </Row>
              </Col>

              <br></br>


            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Autoridad Revisora:
                    </Col>
                    <Col xs={10}>{this.state.autoridad_revisora}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Orden De Auditoria:
                    </Col>
                    <Col xs={10}>{this.state.orden_de_auditoria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Auditoria:
                    </Col>
                    <Col xs={10}>{this.state.no_de_auditoria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Inicio:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_inicio}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Oficio De Solicitud:
                    </Col>
                    <Col xs={10}>{this.state.oficio_de_solicitud}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Acuse:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_acuse}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Oficio De Atencion:
                    </Col>
                    <Col xs={10}>{this.state.oficio_de_atencion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Acuse:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_acuse_1}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estado Actual:
                    </Col>
                    <Col xs={10}>{this.state.estado_actual}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F9as;
